import { create } from 'zustand';

import { ICheckoutBuyerForm } from '../schemas';

export type ICheckoutStateBuyerForm = ICheckoutBuyerForm;

interface ICheckoutStateBuyer {
  buyerForm: ICheckoutStateBuyerForm;
  setBuyerForm: (CheckoutState: ICheckoutStateBuyerForm) => void;
}

export const useBuyerState = create<ICheckoutStateBuyer>(set => {
  return {
    buyerForm: sessionStorage.getItem('buyerForm')
      ? JSON.parse(sessionStorage.getItem('buyerForm')!)
      : ({ type: 'for_company' } as ICheckoutStateBuyerForm),
    setBuyerForm(newBuyerForm: ICheckoutStateBuyerForm) {
      set({ buyerForm: newBuyerForm });
      sessionStorage.setItem('buyerForm', JSON.stringify(newBuyerForm));
    },
  };
});
